import * as Sentry from "@sentry/react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ampli } from "../../../ampli";
import { requestOtp2 } from "../../../setup/api/services/otp";
import { registerByPhone } from "../../../setup/api/services/user";
import { IRegisterByPhoneResponseData } from "../../../setup/api/services/user/models";
// components
import LoginForm from "../login/loginForm";
// constants
import { ERROR_PHONE_VALIDATION } from "../signup/constants";
import { SignupStepper } from "../signup/verticalStepper";
// helpers
import { validatePhoneNumber } from "../validation";
// types
import { ERegionCode } from "../validation/enum";

const AuthEntryPoint = ({
  authAction,
  publicContractLogin,
  toggleOnboarding,
  setToggleOnboarding,
}: any) => {
  const { t } = useTranslation();

  const isInitiallyVisible = false;
  const [isKeyboardVisible, setKeyboardVisible] = useState(isInitiallyVisible);

  useEffect(() => {
    // toggle isKeyboardVisible on event listener triggered
    let timeout: NodeJS.Timeout | null = null;
    window?.visualViewport?.addEventListener("resize", () => {
      timeout && clearInterval(timeout);
      timeout = setTimeout(() => {
        setKeyboardVisible(!isKeyboardVisible);
      }, 1000);
    });
  }, [isKeyboardVisible]);

  const [isActualUser, setIsActualUser] = useState<boolean>();
  const [registeredUser, setRegisteredUser] =
    useState<IRegisterByPhoneResponseData>();
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [error, setError] = useState<string>();

  const sendAmpliViewSignUpPage = useCallback(() => {
    try {
      ampli && ampli.viewedSignUpPage();
    } catch (error) {
      Sentry.captureException(error);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      sendAmpliViewSignUpPage();
    }, 1000);
  }, [sendAmpliViewSignUpPage]);

  useEffect(() => {
    if (
      registeredUser &&
      isActualUser !== undefined &&
      isActualUser === false
    ) {
      sendAmpliUserId(registeredUser.id);
    }
  }, [registeredUser, isActualUser]);

  const sendAmpliUserId = (id: number | string) => {
    ampli.client.setUserId(id.toString());
    ampli.client.setUserProperties({
      userId: id,
    });
  };
  useEffect(() => {
    if (
      registeredUser &&
      isActualUser !== undefined &&
      isActualUser === false
    ) {
      sendAmpliUserId(registeredUser.id);
      sendAmpliViewSignUpPage();
    }
  }, [registeredUser, isActualUser, sendAmpliViewSignUpPage]);

  const onRegisterPhoneNumber = useCallback(
    (phoneNumber: string, otpProvider: "WHATSAPP" | "SMS") => {
      if (validatePhoneNumber(`+${phoneNumber}`, ERegionCode.SA)) {
        registerByPhone({ phoneNumber: `+${phoneNumber}` })
          .then(async (result) => {
            setRegisteredUser(result.data);
            try {
              const body = {
                phoneNumber: `+${phoneNumber}`,
                notificationChannel: otpProvider,
              };
              await requestOtp2(body);
            } catch (error) {
              Sentry.captureException(error);
            }

            setPhoneVerified(true);
            setError(undefined);
          })
          .catch(() => {
            setIsActualUser(false);
          });
      } else {
        setError(ERROR_PHONE_VALIDATION);
      }
    },
    []
  );
  return (
    <>
      {isActualUser !== undefined && isActualUser === false ? (
        <SignupStepper
          publicContractLogin={publicContractLogin}
          setIsActualUser={setIsActualUser}
          authAction={authAction}
          registerationError={error}
          registeredUser={registeredUser}
          phoneVerified={phoneVerified}
        />
      ) : (
        <>
          <LoginForm
            publicContractLogin={publicContractLogin}
            setNonCompletedUser={setRegisteredUser}
            setIsActualUser={setIsActualUser}
            authAction={authAction}
            onRegisterPhoneNumber={onRegisterPhoneNumber}
            registeredUser={registeredUser}
          />
          {toggleOnboarding && !isKeyboardVisible && (
            <div className={"login_footer"}>
              <p
                onClick={() => setToggleOnboarding(!toggleOnboarding)}
                className="subtitle1">
                {t("lbl_learn_about_waffi")}
              </p>
            </div>
          )}
        </>
      )}
    </>
  );
};
export default AuthEntryPoint;
